export const SET_UNSET_PRIMITIVE_ARRAY_ITEM = "SET_UNSET_PRIMITIVE_ARRAY_ITEM";
export const SET_UNSET_OBJECT_ARRAY_ITEM = "SET_UNSET_OBJECT_ARRAY_ITEM";
export const SET_STATE_VALUE = "SET_STATE_VALUE";
export const SWAP_ARRAY_ITEM_LEFT = "SWAP_ARRAY_ITEM_LEFT";
export const SWAP_ARRAY_ITEM_RIGHT = "SWAP_ARRAY_ITEM_RIGHT";
export const REMOVE_ITEM_BY_INDEX = "REMOVE_ITEM_BY_INDEX";
export const APPEND_ITEM_TO_ARRAY = "APPEND_ITEM_TO_ARRAY";
export const PREPEND_ITEM_TO_ARRAY = "PREPEND_ITEM_TO_ARRAY";
